import React, { Component } from 'react'
import { connect } from 'react-redux'
import autoBind from 'auto-bind'
import { Translate } from 'react-localize-redux'

import Select from 'react-select'

import { getPlotsByPartNumber } from '../../store/partNumbers/PartNumberAction'

/**
 * Plot selector container
 *
 * @class PlotSelector
 * @extends {Component}
 */
class PlotSelector extends Component {
	/**
	 *Creates an instance of PlotSelector.
	 * @param {*} props
	 * @memberof PlotSelector
	 */
	constructor(props) {
		super(props)
		autoBind(this)
		this.state = {
			isLoading: true,
			options: [],
			errorLoading: false,
			kind: '',
			formatype: '',
		}
	}

	/**
	 * componentWillMount
	 *
	 * @memberof PlotSelector
	 */
	componentDidMount() {
		this.props
			.getPlotsByPartNumber(this.props.specPlano, this.props.revision, this.props.kind, this.props.formatype)
			.then((plots) => {
				if (plots) {
					let options = plots.map((plot) => {
						return {
							value: plot,
							label: plot,
						}
					})
					this.setState({
						options,
						isLoading: false,
						kind: this.props.kind,
						formatype: this.props.formatype,
					})
				}
			})
			.catch((error) => {
				console.error('Error getting the plots list from SAP', error)
				this.setState({
					errorLoading: true,
				})
			})
	}

	/**
	 * Get the placeholder content
	 *
	 * @returns
	 * @memberof PlotSelector
	 */
	getPlaceHolderContent() {
		if (this.state.errorLoading === true) {
			return <Translate id='plotSelector.errorLoading' />
		} else if (this.state.isLoading === true) {
			return <Translate id='common.loadingPleaseWait' />
		} else {
			return <Translate id='plotSelector.selecPlot' />
		}
	}

	/**
	 * Get the selected plot
	 *
	 * @memberof PlotSelector
	 */
	getSelectedPlot() {
		const { isLoading, options } = this.state
		if (isLoading === false && options.length > 0) {
			let selected = options.find((option) => {
				return option.value === this.props.selectedPlotName
			})
			return selected
		} else {
			return null
		}
	}

	/**
	 *
	 *
	 * @returns
	 * @memberof PlotSelector
	 */
	render() {
		return (
			<Select
				value={this.getSelectedPlot()}
				styles={this.state.errorLoading === true ? customStyles : {}}
				// isDisabled={this.state.isLoading}
				placeholder={this.getPlaceHolderContent()}
				options={this.state.options}
				isClearable
				onChange={(option) => {
					this.props.onPlotSelected(option && option.value)
				}}
				isDisabled={this.props.isDisabled ? this.props.isDisabled || this.state.isLoading : false}
				menuPortalTarget={document.parentNode}
				menuPosition='fixed' //THIS IS REQUIRED IN MODAL!!
				menuPlacement={'auto'}
			/>
		)
	}
}

/**
 *  Defines the properties injecteded from the store to view container
 * @param {*} state
 */
function mapStateToProps(state) {
	return {}
}

/**
 * Defines the actions injectes to the component
 * @param {*} dispatch
 */
const mapDispatchToProps = (dispatch) => {
	return {
		getPlotsByPartNumber: (specPlano, revision, kind, formatype) => {
			return dispatch(getPlotsByPartNumber(specPlano, revision, kind, formatype))
		},
	}
}

const customStyles = {
	placeholder: (styles) => ({ ...styles, color: 'red' }),
	control: (styles) => ({ ...styles, borderColor: 'red' }),
	menu: (base) => ({ ...base, zIndex: 2000 }),
	menuPortal: (base) => ({ ...base, zIndex: 9999 }), /// THIS IS TO SHOW MENU OVER ANY ELEMENT
	menuList: (base) => ({ ...base, zIndex: 2000 }),
}

export default connect(mapStateToProps, mapDispatchToProps)(PlotSelector)
